module.exports = __webpack_public_path__ + "img/twitter.e9eabbae.svg";